/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_TransferAgents_TransferAgentDto } from '../models/Wealthlane_AwardService_Dtos_TransferAgents_TransferAgentDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TransferAgentService {

    /**
     * @returns Wealthlane_AwardService_Dtos_TransferAgents_TransferAgentDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAgentActiveTransferList(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_TransferAgents_TransferAgentDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-agent/active-transfer-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
